// extracted by mini-css-extract-plugin
export default {"page":"XW-z","cartModal":"YW-z","checkout":"ZW-z","placeholder":"_W-z","account":"aX-z"};